import { createAction, props } from '@ngrx/store';

import { SearchResult } from '../search-results/data-access-search.models';

export const overlayToggled = createAction('[Search Page] Overlay toggled', props<{ status: boolean }>());

export const shareButtonClicked = createAction(
  '[Search Page] Social share',
  props<{ network: string; item: SearchResult; fairId: string; pageContext: string }>()
);

export const shareDialogOpened = createAction(
  '[Search Page] Social share dialog ',
  props<{ contentType: string; pageContext: string; context: string; item: SearchResult }>()
);

export const filterChipClicked = createAction(
  '[Search Page] Filter chip clicked',
  props<{ filterType: string; filterId: string }>()
);
